module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("页面名称：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('Input', {
    staticClass: "con-width",
    attrs: {
      "size": "large",
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.frmdata.name),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "name", $$v)
      },
      expression: "frmdata.name"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group clearFix"
  }, [_c('label', {
    staticClass: "control-label tex-left tex-width fl"
  }, [_vm._v("导航显示：")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm"
  }, [_c('i-switch', {
    model: {
      value: (_vm.frmdata.display),
      callback: function($$v) {
        _vm.$set(_vm.frmdata, "display", $$v)
      },
      expression: "frmdata.display"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1), _vm._v(" "), _c('span', {
    staticClass: "check-tip"
  }, [_vm._v("页面名称将出现在导航中")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d0a1728c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/pageset.vue
// module id = 195
// module chunks = 2